import React from "react";
import FaIcon from "../fa-icon/fa-icon";
import ImgIcon from "../img-icon/img-icon";
import IconEnum from "../../enums/icon.enum";
import convertToUpperSnakeCase from "../../helpers/convertToUpperSnakeCase";
import IconProps from "./icon.props";

const Icon = React.memo((props: IconProps) => {
  const getFAKey = (icon: string): IconEnum => {
    const useGetKey: string = convertToUpperSnakeCase(icon);
    return (IconEnum as any)[useGetKey];
  };
  // check if Font Awesome
  const isFA = (icon: string): boolean => Boolean(getFAKey(icon));

  if (!props.icon) {
    return null;
  }

  return isFA(props.icon as string) ? (
    <FaIcon
      className={props.className}
      icon={getFAKey(props.icon)}
      library={props.library}
      size={props.size}
      squared={props.squared}
    />
  ) : (
    <ImgIcon
      alt={props.alt}
      className={props.className}
      icon={props.icon}
      size={props.size}
      squared={props.squared}
      title={props.title}
      theme={props.theme}
    />
  );
});

export default Icon;
